import clsx from 'clsx'
import { motion } from 'motion/react'
import { forwardRef, ReactNode, useMemo } from 'react'
import { TContainer } from '../../types'
import { LayoutButtons } from './LayoutButtons'
import { TileLayoutInfoDisplay } from './TileLayoutInfoDisplay'
import { useAppPageState } from '../../useAppPageState'

export const Tile = forwardRef<
  HTMLDivElement,
  {
    container: TContainer
    children: ReactNode
    invisible?: boolean
  }
>(({ container, children, invisible }, ref) => {
  const { isConfiguringLayout } = useAppPageState()
  const { position, id: containerId } = container
  const { colStart, colSpan, rowStart, rowSpan } = position

  const containerStyles = useMemo(
    () => ({ gridRow: `${rowStart} / span ${rowSpan}`, gridColumn: `${colStart} / span ${colSpan}` }),
    [colSpan, colStart, rowSpan, rowStart]
  )

  return isConfiguringLayout ? (
    <motion.div
      layout
      style={containerStyles}
      // className="relative flex size-full rounded-md border border-dashed border-foreground bg-background/80 shadow-lg"
      className="relative flex size-full border border-dashed border-foreground bg-background/80 shadow-lg"
    >
      <LayoutButtons containerId={containerId} />
      {children}
      <TileLayoutInfoDisplay rowStart={rowStart} colStart={colStart} rowSpan={rowSpan} colSpan={colSpan} />
    </motion.div>
  ) : (
    <div
      ref={ref}
      style={containerStyles}
      // className={clsx('relative flex size-full flex-col gap-y-5 rounded-xl', {
      className={clsx('relative flex size-full flex-col gap-y-5', {
        'snap-start': colStart === 1,
        'bg-background shadow-lg': !invisible,
      })}
    >
      {children}
    </div>
  )
})

Tile.displayName = 'Tile'
